import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { Home, Add, Dashboard, Login, Logout } from "@mui/icons-material";
import { useAuth } from "../../services/auth";
import { toast } from "react-toastify";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://backendapi.vinautochecker.com";

// Helper function to get full avatar URL
const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) return null;

  // If already a full URL, return as is
  if (avatarPath.startsWith("http://") || avatarPath.startsWith("https://")) {
    return avatarPath;
  }

  // Otherwise, construct full URL
  return `${API_BASE_URL}/storage/${avatarPath}`;
};

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
    navigate("/");
    // toast.success("Logged out successfully");
  };

  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            component={RouterLink}
            to="/"
            sx={{
              fontWeight: 700,
              color: "white",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              mr: 2,
            }}
          >
            <Home sx={{ mr: 1 }} />
            Blog
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          {isAuthenticated ? (
            <>
              <Button
                color="inherit"
                component={RouterLink}
                to="/dashboard"
                startIcon={<Dashboard />}
                sx={{ mr: 2 }}
              >
                Dashboard
              </Button>
              <Button
                color="inherit"
                component={RouterLink}
                to="/create-post"
                startIcon={<Add />}
                sx={{ mr: 2 }}
              >
                Create Post
              </Button>

              <IconButton onClick={handleMenu} color="inherit" size="large">
                <Avatar
                  sx={{ width: 36, height: 36 }}
                  alt={user?.name}
                  src={getAvatarUrl(user?.avatar)} // ✅ Use helper function
                >
                  {user?.name?.charAt(0)}
                </Avatar>
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  component={RouterLink}
                  to="/profile"
                  onClick={handleClose}
                >
                  Profile
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <Logout fontSize="small" sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Button
                color="inherit"
                component={RouterLink}
                to="/login"
                startIcon={<Login />}
                sx={{ mr: 2 }}
              >
                Login
              </Button>
              <Button
                variant="contained"
                color="secondary"
                component={RouterLink}
                to="/register"
              >
                Sign Up
              </Button>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
